import Swiper from 'swiper/bundle';
import Dropkick from 'dropkickjs';
//import videoPopup from './components/videoPopup'


export class Components {

	constructor() {
		//new videoPopup()
		jQuery('.whats-on .selects .select .clear').on('click', function (e) {
			jQuery(this).prev().removeClass('active').val('').change()
		})
	}
}